// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f68eefab","725":"f0a5b2f2"}[chunkId] + ".chunk.js";
};